<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户应收账款登记列表'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :filters="filters"
        :multipleSelectionOperation="listMultipleSelectionOperation"
        :pageSize.sync="pageSize"
        :page.sync="page"
        @viewDetail = 'viewDetail'
        @editCredit = 'editCredit'
        class="xzmLR10"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";

  export default {
    name: 'ServerAdminPledgeList',
    data() {
      return {
        filterOptions: {
        },
        page: 1,
        pageSize: 10,
        listData: {},
        listMultipleSelectionOperation: [
        ],
        listColumns: [
          {
            name: '质押编号',
            field: 'pl__pledgeNo'
          },
          {
            name: '客户名称',
            field: 'u__customerName'
          },
          {
            name: '供应链',
            field: 'ct__debtorName'
          },
          {
            name: '质押日期',
            field: 'ct__pledgeDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '质押状态',
            field: 'pl__pledgeStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '单据数据',
            field: 'pl__invoiceCount'
          },
          {
            name: '质押总金额',
            field: 'pl__pledgeAmount'
          },
          {
            name: '单据总金额',
            field: 'pl__totalAmount'
          },
          {
            name: '合同编号',
            field: 'ct__contractNo',
          },
          {
            name: '合同日期',
            field: 'ct__contractDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '操作',
            opts:[
              {
                clickHandler: 'viewDetail',
                class: 'el-icon-info',
                name: '查看'
              },
            ]
          }
        ],
        filters: {
          form: {
            u__customerName: '',
            ct__debtorName: '',
            ct__contractNo: '',
            ct__pledgeDate: []
          },
          columns: [
            {
              label: '客户名称',
              component: 'el-input',
              field: 'u__customerName'
            },
            {
              label: '供应链',
              component: 'el-input',
              field: 'ct__debtorName'
            },
            {
              label: '合同编号',
              component: 'el-input',
              field: 'ct__contractNo'
            },
            {
              label: '质押日期',
              component: 'date-range-picker',
              field: 'ct__pledgeDate'
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerPledgeList()
          }
        }
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'pl.createdDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      page: function () {
        this.getCustomerPledgeList()
      }
    },
    mounted() {
      this.getCustomerPledgeList()
    },
    methods: {
      getCustomerPledgeList: function () {
        xhr.getCustomerPledgeList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
          try {
            this.listData = res.data
          }catch(e){

          }
        })

      },
      viewDetail: function (index, row) {
        try {
          this.$router.push({path: 'Detail?pl.pledgeId='+ row.pl__pledgeId})
        }
        catch (e) {

        }
      },
      editCredit: function (index, row) {
        try{
          this.$router.push({path: 'Edit?pl.pledgeId='+ row.pl__pledgeId})

        }catch (e) {

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/PledgeList.vue